import { Alert } from "@mui/material";
import { useDeepCompareMemo } from "@react-hookz/web";
import { isEmpty } from "lodash-es";
import { type FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import type { MomentFormMoment } from "../types/moment-form-moment";

export const PublishCCWarning: FC<{ recipientCount: number }> = ({ recipientCount }) => {
  const { control, getValues } = useFormContext<MomentFormMoment>();
  useWatch({ control, name: ["cc_bcc"] });
  const cc_bcc = getValues("cc_bcc");

  const { cc, bcc } = useDeepCompareMemo(() => {
    return {
      cc: cc_bcc?.cc ?? [],
      bcc: cc_bcc?.bcc ?? [],
    };
  }, [cc_bcc]);

  if (isEmpty(cc) && isEmpty(bcc)) return null;

  const totalMessages = [...cc, ...bcc].length * recipientCount + recipientCount;

  return (
    <Alert severity={totalMessages >= 50 ? "warning" : "info"} sx={{ mt: 1 }}>
      Your selected CC/BCC recipients will each receive {recipientCount} messages.
      <br />
      <br />
      With CC/BCC we will send a total of {totalMessages} messages.
    </Alert>
  );
};
